<template>
  <div class="cerca-linhas-table d-flex flex-column pa-2">
    <v-alert v-if="!cerca || cerca.id_cerca == null" type="info" dense outlined>
      {{ $t('crudLinhas.detail.selectResource') }}
    </v-alert>
    <template v-else>
      <v-text-field
        v-model="searchLinhas"
        append-icon="mdi-magnify"
        :label="$t('crudLinhas.search')"
        single-line
        hide-details
        dense
        clearable
        class="mb-2 flex-grow-0"
      />

      <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-2 flex-grow-0" />

      <v-list dense class="cerca-linhas-table__list flex-grow-1 py-0">
        <v-list-item
          v-for="item in linhasFiltradas"
          :key="linhaKey(item)"
          @click="toggleSelection(item)"
        >
          <v-list-item-action class="mr-2">
            <v-simple-checkbox
              :value="isSelected(item)"
              color="primary"
              @input="toggleSelection(item)"
              @click.stop
            />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.nome_linha || item.cod_linha || item.id_linha }}</v-list-item-title>
            <v-list-item-subtitle v-if="item.cod_linha || item.id_sentido != null">
              <template v-if="item.cod_linha && item.nome_linha">{{ item.cod_linha }}</template>
              <template v-if="item.id_sentido != null">
                <template v-if="item.cod_linha && item.nome_linha"> · </template>
                {{ $t('crudLinhas.detail.schedule.direction') }}: {{ item.id_sentido }}
              </template>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="!loading && !linhasFiltradas.length">
          <v-list-item-content>
            <v-list-item-title class="text--secondary text-body-2">
              {{ emptyListMessage }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </div>
</template>

<script>
import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";

export default {
  name: "CercaLinhasTable",
  props: {
    cerca: { type: Object, default: null },
    token: { type: String, default: null },
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      linhas: [],
      searchLinhas: "",
      loading: false,
      requestSeq: 0,
    };
  },
  computed: {
    selectedKeys() {
      return new Set((this.value || []).map((item) => this.linhaKey(item)));
    },
    linhasFiltradas() {
      const list = this.linhas || [];
      const q = (this.searchLinhas || "").trim().toLowerCase();
      if (!q) return list;
      return list.filter((l) => {
        const fields = [l.nome_linha, l.cod_linha, l.id_linha, l.id_sentido];
        return fields.some((f) => f != null && String(f).toLowerCase().includes(q));
      });
    },
    emptyListMessage() {
      if ((this.linhas || []).length && (this.searchLinhas || "").trim()) {
        return this.$t("crudUnidades.lines.emptySearch");
      }
      return this.$t("crudUnidades.lines.empty");
    },
  },
  watch: {
    cerca: {
      immediate: true,
      handler() {
        this.searchLinhas = "";
        this.emitSelection([]);
        this.load();
      },
    },
  },
  methods: {
    linhaKey(item) {
      if (!item) return "";
      return `${item.id_linha}_${item.id_sentido}`;
    },
    isSelected(item) {
      return this.selectedKeys.has(this.linhaKey(item));
    },
    emitSelection(next) {
      this.$emit("input", next);
      this.$emit("selection-changed", next);
    },
    toggleSelection(item) {
      if (!item) return;
      const key = this.linhaKey(item);
      const current = Array.isArray(this.value) ? [...this.value] : [];
      const idx = current.findIndex((row) => this.linhaKey(row) === key);
      if (idx >= 0) current.splice(idx, 1);
      else current.push({ ...item });
      this.emitSelection(current);
    },
    async load() {
      const id = this.cerca && this.cerca.id_cerca;
      if (id == null) {
        this.linhas = [];
        return;
      }
      const seq = ++this.requestSeq;
      this.loading = true;
      try {
        const res = await apiController.request(apiController.endpoints.getLinhasbycerca, {
          params: { idCerca: id },
          silent: true,
        });
        if (seq !== this.requestSeq) return;
        this.linhas = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        if (seq !== this.requestSeq) return;
        this.linhas = [];
        EventBus.$emit("show-error", { error: e });
      } finally {
        if (seq === this.requestSeq) this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.cerca-linhas-table__list {
  overflow-y: auto;
  min-height: 0;
}
</style>
